// Razorpay Configuration
// ⚠️ SECURITY WARNING: Never commit API keys to version control
// Use environment variables instead

const RAZORPAY_CONFIG = {
  // Keys from environment variables - set these in your .env file
  KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,
  KEY_SECRET: process.env.REACT_APP_RAZORPAY_KEY_SECRET,
  
  // API Base URL
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.tabtrips.com',
  
  // Environment
  ENVIRONMENT: process.env.NODE_ENV || 'development'
};

// Validate configuration
export const validateRazorpayConfig = () => {
  const isValid = RAZORPAY_CONFIG.KEY_ID && RAZORPAY_CONFIG.KEY_SECRET;
  
  if (!isValid) {
    console.warn('⚠️ Razorpay configuration incomplete. Please check your environment variables.');
  }
  
  return isValid;
};

export default RAZORPAY_CONFIG; 